import React from "react";
import styled from "@emotion/styled";
import { useNavigate } from "react-router-dom";

import {
  Tooltip,
  Menu,
  MenuItem,
  IconButton as MuiIconButton,
  Avatar,
} from "@mui/material";

import useAuth from "../../hooks/useAuth";
import { useTranslation } from "react-i18next";
import AzureADAvatar from "../avatars/AzureADAvatar";

const IconButton = styled(MuiIconButton)`
  svg {
    width: 22px;
    height: 22px;
  }
`;

function NavbarUserDropdown() {
  const { t } = useTranslation();
  const [anchorMenu, setAnchorMenu] = React.useState<any>(null);
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const toggleMenu = (event: React.SyntheticEvent) => {
    setAnchorMenu(event.currentTarget);
  };

  const closeMenu = () => {
    setAnchorMenu(null);
  };

  const handleSignOut = async () => {
    await logout();
    navigate("/auth/sign-in");
  };

  return (
    <React.Fragment>
      <IconButton
        aria-owns={Boolean(anchorMenu) ? "menu-appbar" : undefined}
        aria-haspopup="true"
        onClick={toggleMenu}
        color="inherit"
        size="large"
      >
        {!!user && user?.account ? ( // user.account is from Outseta
          <Tooltip
            title={`${user?.displayName}${
              user?.email ? ` (${user.email})` : ``
            }`}
            arrow
            placement="top"
          >
            <Avatar alt={user.displayName} src={user.avatar} />
          </Tooltip>
        ) : (
          <AzureADAvatar userId={user?.id} pictureOnly />
        )}
      </IconButton>

      <Menu
        id="menu-appbar"
        anchorEl={anchorMenu}
        open={Boolean(anchorMenu)}
        onClose={closeMenu}
      >
        <MenuItem onClick={() => navigate("/profile")}>{t("Profile")}</MenuItem>
        <MenuItem onClick={handleSignOut}>{t("Sign out")}</MenuItem>
      </Menu>
    </React.Fragment>
  );
}

export default NavbarUserDropdown;
